import api from "@/api/axios";
import lodash from "lodash";
import { defaultTaskStatuses } from "@/utils/tasks";

const apiUrl = "/api"

export default {
	state: {
		data: {
			Settings: [],
			Loyalty: [],
			UserGroups: [],
			Tasks: [],
			TaskStatuses: [],
			TaskTypes: [],
			TaskUsers: [],
			DocsMenu: [],
			Trades: [],
		},
		update: {
			Settings: null,
			Loyalty: null,
			UserGroups: null,
			Tasks: null,
			TaskStatuses: null,
			TaskTypes: null,
			TaskUsers: null,
			DocsMenu: null,
			Trades: null,
		}
	},
	getters: {
		settings: state => state.data.Settings,
		userGroups: state => state.data.UserGroups,
		loyalty: state => state.data.Loyalty,
		tasks: state => state.data.Tasks,
		taskStatuses: state => state.data.TaskStatuses,
		taskTypes: state => state.data.TaskTypes,
		taskUsers: state => state.data.TaskUsers,
		docsMenu: state => state.data.DocsMenu,
		trades: state => state.data.Trades,
		tradesTime: state => state.update.Trades,
	},
	actions: {
		getApiData({ commit }, data) {
			return api.get(`${ apiUrl }/get/`, { params: data }).then(response => {
				commit("setData", {
					type: data.type,
					data: response.data
				});
				
				return response.data;
			});
		},
		getOnlineData({ commit }, data) {
			const name = data.type.charAt(0).toLowerCase() + data.type.slice(1)
			
			return api.get(`${ apiUrl }/get-${ name }`, { params: data }).then(response => {
				commit("setData", {
					type: data.type,
					data: response.data
				});
				
				return response.data;
			});
		},
		setApiData({ commit }, data) {
			return api.post(
				`${ apiUrl }/set/?type=${ data.type }${ data.returnSaved ? '&returnSaved=1' : '' }`,
				{ 'data': data.data, checkDuplicates: data.checkDuplicates }
				)
				.then((response) => {
					if (response.data.errors) {
						return response.data;
					} else {
						if (data.deleteData) {
							commit("deleteData", {
								type: data.type,
								data: {
									value: data.value,
									key: data.key
								}
							});
						} else if (response.data) {
							if (data.returnSaved) {
								commit("setSome", {
									id: data.id,
									type: data.type,
									data: response.data
								});
							} else {
								commit("setData", {
									type: data.type,
									data: response.data
								});
							}
						}
						
						return response.data;
					}
				});
		},
		deleteApiData({ commit }, data) {
			return api.delete(`${ apiUrl }/delete/?type=${ data.type }`, { params: data.data }).then((response) => {
				commit("deleteData", {
					type: data.type,
					data: response.data
				});
			});
		},
	},
	mutations: {
		setSome(state, data) {
			const oldData = state.data[data.type];
			const newData = new Map(data.data.map(item => [ Number(item[data.id]), item ]));
			
			const updatedIds = new Set();
			
			const updatedData = oldData.map(oldItem => {
				const id = Number(oldItem[data.id]);
				if (newData.has(id)) {
					updatedIds.add(id); // Запоминаем, что этот id обработан
					return newData.get(id);
				}
				return oldItem;
			});
			
			for (const [ id, newItem ] of newData.entries()) {
				if (!updatedIds.has(id)) {
					updatedData.push(newItem);
				}
			}
			
			state.data[data.type] = updatedData;
			state.update[data.type] = new Date();
			
			return {
				...state.data,
				[data.type]: updatedData.filter(item => !!item.isDeleted && item.isDeleted == 0 || !item.isDeleted)
			};
		},
		setData(state, data) {
			if (data.type == 'TaskStatuses') {
				if (data.data.length == 0) {
					data.data = defaultTaskStatuses()
				}
			}
			
			if (data.type == 'Settings') {
				data.data = data.data.reduce((acc, item) => {
					if (item.settingValue !== '') {
						acc[item.settingName] = item.settingName === 'schedule' ? JSON.parse(item.settingValue) : item.settingValue;
					}
					
					return acc;
				}, {})
			}
			
			state.update[data.type] = new Date();
			state.data = { ...state.data, [data.type]: data.data }
		},
		deleteData(state, data) {
			if (state.data[data.type]) {
				state.data = {
					...state.data,
					[data.type]: state.data[data.type].filter(item => (item[data.data.key] !== data.data.value))
				}
			}
		}
	}
};
